var styles = {
  "Expander": "pb-Expander__Expander",
  "toggleButton": "pb-Expander__toggleButton",
  "icon": "pb-Expander__icon",
  "toggleButton--expanded": "pb-Expander__toggleButton--expanded",
  "closeButtonContainer": "pb-Expander__closeButtonContainer",
  "content": "pb-Expander__content"
};
export default styles;